import {createAction} from 'web-app/util/redux/famly-app-helpers';

import type * as Types from './types';

const domain = 'FAMLY_LIVE';

export const {
    action: createMeeting,
    success: createMeetingSuccess,
    failed: createMeetingFailed,
} = createAction(
    `${domain}/CREATE_MEETING`,
    (payload: {addFamlyLiveMeetingToPost: (famlyLiveMeetingId: string) => void}) => ({payload}),
    (famlyMeeting: Types.FamlyMeeting) => ({famlyMeeting}),
);

export const {
    action: joinMeeting,
    success: joinMeetingSuccess,
    failed: joinMeetingFailed,
} = createAction(
    `${domain}/JOIN_MEETING`,
    (meetingId: string, joinToken?: string) => ({meetingId, joinToken}),
    (famlyMeetingId: string) => ({famlyMeetingId}),
);

export const {
    action: startLocalVideo,
    success: startLocalVideoSuccess,
    failed: startLocalVideoFailed,
} = createAction(
    `${domain}/START_LOCAL_VIDEO`,
    (videoDevice: MediaDeviceInfo | null) => ({videoDevice}),
    (videoDevice: MediaDeviceInfo | null) => ({videoDevice}),
);

export const {
    action: stopLocalVideo,
    success: stopLocalVideoSuccess,
    failed: stopLocalVideoFailed,
} = createAction(`${domain}/STOP_LOCAL_VIDEO`, () => ({}));

export const {
    action: muteLocalAudio,
    success: muteLocalAudioSuccess,
    failed: muteLocalAudioFailed,
} = createAction(`${domain}/MUTE_LOCAL_AUDIO`, () => ({}));

export const {
    action: unmuteLocalAudio,
    success: unmuteLocalAudioSuccess,
    failed: unmuteLocalAudioFailed,
} = createAction(`${domain}/UNMUTE_LOCAL_AUDIO`, () => ({}));

export const {
    action: getMeeting,
    success: getMeetingSuccess,
    failed: getMeetingFailed,
} = createAction(
    `${domain}/GET_MEETING`,
    (famlyLiveMeetingId: string, refreshToken: string) => ({
        famlyLiveMeetingId,
        refreshToken,
    }),
    (famlyMeeting: Types.FamlyMeeting) => ({famlyMeeting}),
);

export const {action: tileDidUpdate} = createAction(`${domain}/TILE_UPDATED`, (tile: Types.TileState) => ({
    tile,
}));
export const {action: tileDeleted} = createAction(`${domain}/TILE_DELETED`, (tileId: number) => ({tileId}));

export const {
    action: getJoinToken,
    success: getJoinTokenSuccess,
    failed: getJoinTokenFailed,
} = createAction(
    `${domain}/GET_JOIN_TOKEN`,
    (famlyLiveMeetingId: string) => ({famlyLiveMeetingId}),
    (externalJoinUrl: string) => ({externalJoinUrl}),
);

export const {action: setRefreshToken} = createAction(`${domain}/SET_REFRESH_TOKEN`, (refreshToken: string) => ({
    refreshToken,
}));

export const {action: addAttendeeId} = createAction(`${domain}/ADD_ATTENDEE_ID`, (attendeeId: string) => ({
    attendeeId,
}));

export const {action: removeAttendeeId} = createAction(`${domain}/REMOVE_ATTENDEE_ID`, (attendeeId: string) => ({
    attendeeId,
}));

export const {action: reset} = createAction(`${domain}/RESET`, () => ({}));

export const {action: leaveMeeting, success: leaveMeetingSuccess} = createAction(`${domain}/LEAVE_MEETING`, () => ({}));

export const {action: deviceNotFoundError} = createAction(
    `${domain}/DEVICE_NOT_FOUND_ERROR`,
    (deviceType: Types.DEVICE_NOT_FOUND) => ({deviceType}),
);

export const {action: multipleTilesTrackingEventSent} = createAction(
    `${domain}/MULTIPLE_TILES_TRACKING_EVENT_SENT`,
    () => ({}),
);

export const {action: updateAudioInputDeviceList} = createAction(
    `${domain}/UPDATE_AUDIO_INPUT_DEVICE_LIST`,
    (audioInputDeviceList: MediaDeviceInfo[]) => ({audioInputDeviceList}),
);

export const {action: updateAudioOutputDeviceList} = createAction(
    `${domain}/UPDATE_AUDIO_OUTPUT_DEVICE_LIST`,
    (audioOutputDeviceList: MediaDeviceInfo[]) => ({audioOutputDeviceList}),
);

export const {action: updateVideoInputDeviceList} = createAction(
    `${domain}/UPDATE_VIDEO_INPUT_DEVICE_LIST`,
    (videoInputDeviceList: MediaDeviceInfo[]) => ({videoInputDeviceList}),
);

export const {
    action: setSelectedAudioInputDevice,
    success: setSelectedAudioInputDeviceSuccess,
    failed: setSelectedAudioInputDeviceFailed,
} = createAction(
    `${domain}/SET_SELECTED_AUDIO_INPUT_DEVICE`,
    (audioInputDevice: MediaDeviceInfo | null) => ({
        audioInputDevice,
    }),
    (audioInputDevice: MediaDeviceInfo | null) => ({
        audioInputDevice,
    }),
);

export const {
    action: setSelectedAudioOutputDevice,
    success: setSelectedAudioOutputDeviceSuccess,
    failed: setSelectedAudioOutputDeviceFailed,
} = createAction(
    `${domain}/SET_SELECTED_AUDIO_OUTPUT_DEVICE`,
    (audioOutputDevice: MediaDeviceInfo | null) => ({
        audioOutputDevice,
    }),
    (audioOutputDevice: MediaDeviceInfo | null) => ({
        audioOutputDevice,
    }),
);

export const {
    action: setSelectedVideoInputDevice,
    success: setSelectedVideoInputDeviceSuccess,
    failed: setSelectedVideoInputDeviceFailed,
} = createAction(
    `${domain}/SET_SELECTED_VIDEO_INPUT_DEVICE`,
    (videoInputDevice: MediaDeviceInfo | null) => ({
        videoInputDevice,
    }),
    (videoInputDevice: MediaDeviceInfo | null) => ({
        videoInputDevice,
    }),
);

export const {action: attendeeVolumeInfoDidChange} = createAction(
    `${domain}/ATTENDEE_VOLUME_INFO_DID_CHANGE`,
    (boundAttendeeId: string, volume: number, muted: boolean, signalStrength: number) => ({
        boundAttendeeId,
        volume,
        muted,
        signalStrength,
    }),
);

export const {action: removeAttendeeVolumeInfo} = createAction(
    `${domain}/REMOVE_ATTENDEE_VOLUME_INFO`,
    (boundAttendeeId: string) => ({boundAttendeeId}),
);
